const templates = state => state.templates
const template = state => state.template
const sections = state => state.sections
const pagination = state => state.pagination
const size = state => state.size
const isLoading = state => state.loading
const listPlayers = state => {
  return [].concat(...state.sections.map(section => section._players))
}
const search = state => state.search

// const cardIsCreated = state => !!state.card.id

export default {
  templates,
  template,
  sections,
  size,
  pagination,
  isLoading,
  listPlayers,
  search
}



// WEBPACK FOOTER //
// ./src/store/modules/templates/getters.js